/* Package JSON Import will be here */
import React from "react";
import { Icon, Header, Segment, Table, Pagination, Button, Modal, Form, Input, Search } from 'semantic-ui-react';
/* Package JSON Import will be here */

/* Project Import will be here */
import Layout from "../../comman/Layout/Layout";
import { Constants } from '../../../src/config/appConstants';
// import './divisions.css';
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import NoResultFound from "../sharedComponent/noResultFound";
import * as utility from '../../services/utility';
/* Project Import will be here */

const DivisionComponent = props => {
    const myiconstyle = { color: "#f18f40", margin: "5px", cursor: "pointer" };
    return (

        <Layout>
            <Segment className="header-section">
                <Header as="h3">
                    <Icon name="disk"></Icon>
                    <span>Divisions</span>
                </Header>
                <i aria-hidden="true"
                    onClick={() => { props.onOpenModel({ data: {} }); }}
                    style={myiconstyle} className="plus circle icon">
                </i>
            </Segment>
            <Table className="ui celled table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className="tableCell"></Table.HeaderCell>
                        <Table.HeaderCell className="text-left">
                            Division Number
                            <Search className="theader" onSearchChange={props.onDivisionSearch}
                                placeholder={Constants.SEARCH_PLACEHOLDER} />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.division.divisionDataList && props.division.divisionDataList.length > 0 ? props.division.divisionDataList.map(({ divisionName, divisionId, status }) => (
                        <Table.Row>
                            <Table.Cell textAlign="center" className="tableCell">
                                <Icon className="myiconstyle" edit name='edit pencil'
                                    onClick={() => {
                                        props.onOpenModel({ divisionId: divisionId });
                                    }}
                                />
                            </Table.Cell>
                            <Table.Cell>{divisionName}</Table.Cell>
                        </Table.Row>
                    )) :
                        <Table.Row>
                            <Table.Cell colSpan='2'>
                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table.Body>
            </Table>

            <Modal closeIcon
                open={props.division.isOpenModel}
                closeOnDimmerClick={false}
                onClose={() => { props.onCloseModel(); }}
                size='tiny'
            >
                <Modal.Header>Add Division</Modal.Header>
                <Modal.Content scrolling>
                    <Form>
                        <Form.Group inline widths='equal'>
                            <Form.Field required>
                                <label>Division Number:</label>
                                <Input
                                    placeholder='Enter Division Number'
                                    value={props.division.selectedValue ? props.division.selectedValue.divisionName : ""}
                                    onChange={(e) => { utility.allowAllValuesExceptSpace(e); props.handleDivisionNameChange(e, { name: 'divisionName', value: e.target.value }) }}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {props.division.isEditDivision ?
                        <Button disabled={props.division.isSetButtonDisabled} type="submit" primary onClick={() => props.onSaveDivision(props.division.selectedValue.divisionId, null)}> Update </Button> :
                        <Button disabled={props.division.isSetButtonDisabled} type="submit" primary onClick={() => props.onSaveDivision()}> Save </Button>
                    }
                    <Button secondary onClick={() => props.onCloseModel()} > Back </Button>
                    {/*{props.division.isEditDivision && <Button disabled={props.division.isSetButtonDisabled} primary floated="right" color='blue' type="submit" onClick={() => props.onClickSetButton(props.division.selectedValue.divisionId, props.division.selectedValue.status)}> Set Active / Inactive </Button>}*/}
                </Modal.Actions>
            </Modal>
            {/*<Confirm
                closeIcon
                open={props.division.isSetButtonConfirm}
                content={`The division with ${props.division.selectedValue.divisionName} is already associated with one or more users, If made inactive this division may no longer be associated with the respective users. Do you still want to make it inactive?`}
                header='Confirmation'
                size="tiny"
                onCancel={() => { props.onCancelConfirm(); }}
                onConfirm={() => { props.onSaveDivision(props.division.selectedValue.divisionId, props.division.selectedValue.status); }}
            />*/}
            {props.division.divisionDataList && props.division.divisionDataList.length > 0 &&
                <Pagination floated="right"
                    activePage={props.division.pagination.activePage}
                    onPageChange={props.onPageChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.division.pagination.totalCount} />
            }
        </Layout >
    );
}

export default DivisionComponent;

DivisionComponent.displayName = "DivisionComponent";